// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const HeaderUpload: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
            <path
                fill="currentColor"
                d="M15.6389194,0 C16.5340399,0 17.3523928,0.505779275 17.7529075,1.30648055 L18.0163821,1.83342976 C18.089559,1.97978337 18.238906,2.07208023 18.4025558,2.07208023 L20.7730508,2.07208023 C23.1075562,2.07208023 25,3.96452408 25,6.29902944 L25,16.6651246 L24,16.6651246 L24,6.29902944 C24,4.51680883 22.5552714,3.07208023 20.7730508,3.07208023 L18.4025558,3.07208023 C17.8601427,3.07208023 17.3645277,2.76578884 17.121955,2.28064336 L16.858517,1.75376748 C16.6274444,1.2918117 16.1552919,1 15.6389194,1 L9.36108056,1 C8.84470806,1 8.37255556,1.2918117 8.14151965,1.75369415 L7.87804504,2.28064336 C7.6354723,2.76578884 7.13985731,3.07208023 6.59744419,3.07208023 L4.22694921,3.07208023 C2.44386434,3.07208023 1,4.51663741 1,6.29902944 L1,20.7730508 C1,22.5554428 2.44386434,24 4.22694921,24 L16.6651246,24 L16.6651246,25 L4.22694921,25 C1.89147217,25 0,23.1076202 0,20.7730508 L0,6.29902944 C0,3.96446002 1.89147217,2.07208023 4.22694921,2.07208023 L6.59744419,2.07208023 C6.76109402,2.07208023 6.91044104,1.97978337 6.98361785,1.83342976 L7.24712913,1.30640722 C7.64760723,0.505779275 8.46596011,0 9.36108056,0 L15.6389194,0 Z M22,18 L22,21 L25,21 L25,22 L22,22 L22,25 L21,25 L21,22 L18,22 L18,21 L21,21 L21,18 L22,18 Z M12.5,8.75 C14.9852814,8.75 17,10.7647186 17,13.25 C17,15.7352814 14.9852814,17.75 12.5,17.75 C10.0147186,17.75 8,15.7352814 8,13.25 C8,10.7647186 10.0147186,8.75 12.5,8.75 Z"
            />
        </svg>
    );
};

export default React.memo(HeaderUpload);
